// extracted by mini-css-extract-plugin
export var dataCell = "_o7-2";
export var dataRow = "_o7-0";
export var headerRow = "_o7-1";